import moment from 'moment'

export const cleanData2Table = (prevData, currentData, noData) =>{
    let temp = {
        id: currentData.id_ctrl_publicity,
        completed: currentData.completed ? true : false,
        files:[],
        data:[]
    }

    let fixedDataA = [
        currentData.businesses_name ? currentData.businesses_name : noData,
        currentData.rfc ? currentData.rfc : noData,
        currentData.client_status ? currentData.client_status : noData,
        currentData.client_classification ? currentData.client_classification : noData,
        currentData.fiscal_regime ? currentData.fiscal_regime : noData
    ];

    let fixedDataB = [
        currentData.publicity_requirements ? currentData.publicity_requirements : noData,
        currentData.publicity_due_date ? moment(currentData.publicity_due_date).format('DD-MM-YYYY') : noData,
        currentData.publicity_process ? currentData.publicity_process : noData,
        currentData.publicity_periodicity ? currentData.publicity_periodicity : noData,
        currentData.publicity_responsible ? currentData.publicity_responsible : noData,
        currentData.publicity_comments ? currentData.publicity_comments : noData,
        currentData.publicity_projects_costs ? currentData.publicity_projects_costs.toString() : noData,
        {key:'publicity_documents'},
        currentData.publicity_provider ? currentData.publicity_provider : noData,

    ]
    
    let varData = [
        {key:'recepit'},
        currentData.process_status ? currentData.process_status : noData,
        currentData.delivery_date ? moment(currentData.delivery_date).format('DD-MM-YYYY') : noData,
        currentData.responsible ? currentData.responsible : noData,
        currentData.notes ? currentData.notes : noData,
        currentData.extra_hours ? currentData.extra_hours : noData,
        {key:'hours_proof'},
        currentData.extra_charges ? currentData.extra_charges : noData,
        {key:'charge_proof'},
        currentData.collections_charge ? currentData.collections_charge : noData,
        currentData.completition_date ? moment(currentData.completition_date).format('DD-MM-YYYY') : noData,
    ]

    let origin_data = {
        process_status_id: currentData.process_status_id,
        delivery_date : currentData.delivery_date,
        responsible_id: currentData.responsible_id,
        notes : currentData.notes,
        extra_hours : currentData.extra_hours,
        extra_charges : currentData.extra_charges,
        collections_charge : currentData.collections_charge,
        completition_date : currentData.completition_date
    }

    let tempA = {...temp}
    tempA.data = [...fixedDataA]
    prevData.fixedDataA.push(tempA);

    let tempB = {...temp}
    tempB.data = [...fixedDataB]
    tempB.files = [
        {id:currentData.id_ctrl_publicity,key:'publicity_documents',name:'Adjuntar Documentos',path:'publicitydocuments',
            status: checkStatus(currentData, 'publicity_documents')}
    ]
    prevData.fixedDataB.push(tempB);

    let tempVar = {...temp}
    tempVar.data = [...varData]
    tempVar.files = [
        {id:currentData.id_ctrl_publicity,key:'recepit',name:'Acuse',path:'recepit',
            status: checkStatus(currentData, 'recepit')},
        {id:currentData.id_ctrl_publicity,key:'hours_proof',name:'Comprobante de horas',path:'hoursproof',
            status: checkStatus(currentData, 'hours_proof')},
        {id:currentData.id_ctrl_publicity,key:'charge_proof',name:'Tabla SAT',path:'chargeproof',
            status: checkStatus(currentData, 'charge_proof')}
    ]
    tempVar.origin_data = {...origin_data}
    
    prevData.varData.push(tempVar);
    return prevData;
}

const checkStatus = (item, key) => {
    return item[key] !== "0" && item[key] !== 0 && item[key] !== ""
}
